<template>
  <v-main>
    <head>
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
    </head>
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 320px) and (max-width: 639px)" >
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 640px) and (max-width: 1023px)" >
    <link href="desktop.css" rel="stylesheet" type="text/css" media="(min-width: 1024px)" >
  <div>
  <v-container>
    <v-card
      class="mx-8 rounded-xl card"
      color="white"
      elevation="1"
      outlined
      style="border:medium solid #707070;"
    >
      <v-card-title>
        <!--LiquitousAccountの作成画像-->
        <v-img
          class="pic1"
          src="../../assets/jpg/createAccountTitle.jpg"
          
        >
        </v-img>
      </v-card-title>
      <v-card-actions class="mb-2">
        <v-row>
          <v-col class="" cols="">
            <p class="mb-0 name-font">ハンドルネーム</p>
            <v-form v-model="valid">
              <v-row>
                <v-col
                  class="name"
                >
                  <v-text-field
                    v-model="handlename"
                    :rules="nameRules"
                    :counter="20"
                    placeholder="Handle name"
                    required
                    width="50"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <p class="mb-0 mail-font">職員番号</p>
            <v-col
              class="mail"
            >
              <v-text-field
                class="text-input-black ma-0"
                v-model="number"
                :rules="[rules.required, rules.number]"
                placeholder="職員番号"
              ></v-text-field>
            </v-col>
            <p class="password-font">パスワード</p>
            <v-col
              class="password"
            >
              <v-text-field
                class="text-input-black ma-0"
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.password]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                placeholder="Password"
                hint="英数字8文字以上・大文字、小文字、数字必須"
                counter
                @click:append="show1 = !show1"
              ></v-text-field>
              <div class="text-right rule">英数字8文字以上・大文字、小文字、数字必須</div>
            </v-col>
            <p class="password-font">合言葉</p>
            <v-col
              class="password"
            >
              <v-text-field
                class="text-input-black ma-0"
                v-model="aikotoba"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="show2 ? 'text' : 'password'"
                name="input-10-2"
                placeholder="共有済みの合言葉コード"
                counter
                @click:append="show2 = !show2"
              ></v-text-field>
            </v-col>
          </v-col>

          <v-divider
          vertical
          ></v-divider>
          
          <v-col class="a-font" cols="6">
            <div class="errbar-font">
              <p v-if="noac===true">アカウントが既に作成されています<br>上記のタブから「サインイン」を開いてください。</p>
              <p v-if="this.aller===true">入力内容に誤りがあります<br>全ての項目を正しく入力してください</p>
              <p v-if="emer===true">メールアドレスの形式が違います<br>もう一度正しく入力してください</p>
              <p v-if="pwer===true">パスワードの作成条件を<br>満たしてください</p>
              <p v-if="aiker===true">合言葉が違います。確認し、正しく入力してください<br>連続して一定回数間違えるとロックされますのでご注意ください。</p>
              <p v-if="locker===true">合言葉が間違えられた回数が一定回数を超えました<br>しばらくしてから再度お試しください</p>
            </div>
            <div class="look-font">
              以下の注意事項を必ずお読みください
            </div>
            <ul class="links" >
              <li><a href="https://drive.google.com/file/d/13yqWr0tXj2eb8898OBl_EbukMIASPZuK/view?usp=sharing" target=”_blank”>Liquitous Account 利用規約</a></li>
              <p></p>
              <li><a href="https://drive.google.com/file/d/1fSPDIhzqH4BPfpUUCPvTSGy8_d227hCP/view" target=”_blank”>プライバシーポリシー</a></li>
            </ul>
            <p class="download-font">上記の２つをダウンロードして閲覧する場合は<span><a href="https://drive.google.com/file/d/1sOVrGMspt3bUgiglo8ygGhPhaiPo_cuz/view?usp=share_link" target=”_blank”>こちら(PDF)</a></span></p>
            <div class="">
              <v-checkbox
                class="checkbox"
                v-model="checkbox"
                label="上記の規約に同意します"
                style="padding-left: 0%;"
              ></v-checkbox>
              <v-btn
                large
                :disabled="!checkbox||!number||!password||!handlename||!aikotoba"
                class="signupbtn"
                color="#008cff"
                @click="reseterr(),signup()"
                style="text-transform: none; font-family: mplus-2c-bold; border-width:3px;"
                outlined
              >
                Sign Up
              </v-btn>
            </div>
          </v-col>
        </v-row>

      </v-card-actions>
      <v-card-actions class="back" style="font-size:40px;">
        <v-btn
               class="back"
               color="black"
               text
               
               href="/home">
             <span style="color:#008CFF">＜</span> &nbsp; &nbsp;戻る &nbsp; &nbsp;<span style="color:#008CFF">＞</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
  </div>
  </v-main>
</template>
<script>
import firebase from 'firebase'
import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
const thisEnvId = process.env.VUE_APP_TEMP_CITY_ID || '';
export default {
  data () {
    return {
      show1: false,
      show2: false,
      valid: false,
      checkbox: false,
      handlename: '',
      number: '',
      password: '',
      aikotoba: '',
      token: '',
      pwer: false,
      emer: false,
      acer: true,
      aiker: false,
      locker: false,
      noac: false,
      aller: true,
      nameRules: [
        v => !!v || '名前を入力してください',
        v => v.length <= 20 || '10文字以下で入力してください',
      ],
      rules: {
        required: value => !!value || '入力内容に誤りがあります',
        number: v => !(!(v.match(/^[0-9]+/))) || 'この職員番号は有効ではありません',
        password:v => v.match(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/) || '英数字8文字以上・大文字、小文字、数字必須です',
        min: v => v.length >= 8 || '8文字以上で入力して下さい',
      },
    }
  },
  methods: {
    async signup() {
      try {
        this.loading = true
        var self = this
        const functions = firebase.functions()
        const numberSignup = functions.httpsCallable(`numberSignup`)
        const { data } = await numberSignup({ numberId: this.number, password: this.password, name: this.handlename, aikotoba: this.aikotoba, environment: thisEnvId })
        //console.log(res)
        if (data.customToken) {
          this.$store.dispatch('auth/useCustomToken', data.customToken)
          this.$router.push('/home')
        }
      } catch (error) {
        this.loading = false
        if (error.message == 'user already exists') {this.noac = true}
        else {alert('エラーが発生しました。内容をご確認いただき再度お試しください')}
        console.error(error.meesage)
      }
    },
    reseterr(){
    this.pwer = false,
    this.emer = false,
    this.acer = false,
    this.noac = false,
    this.aiker = false,
    this.locker = false,
    this.aller = false
    },
  },
  mounted(){
    this.reseterr();
  }
}
</script>

<style scoped>
.all{
  position: fixed;
  top:15%;
  left:20%;
}
.logotitle{
  position: relative;
  left: 30%;
}
.custom-label-color{
  color: black;
  opacity: 1;
}
.custom-color {
  border-color: #707070;
}
.signup {
  background-size:cover;
  width:100%;
  height:100%;
}
.signupbutton{
  font-size: 25px;
  position: relative;
  left: 0%;
}

.errbar{
  border-left: solid #E64550;
  border-right: solid #E64550;
  color: #E64550;
}
.margin{
  margin-top: 5%;
}
.return{
  position: fixed;
  bottom: 10%;
  left: 45%;
}
*{
  font-family:mplus-2c-medium;
  color: #2B2B2B;
}
/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/


/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width:1280px) {
.card{
  top:50px;
}
.pic1{
  position: relative;
  max-width: 40%;
  left: 31%;
}
.signup{
  position: relative;
  left: 70px;
  top:120px;
}
.back{
  position: relative;
  top:100px; 
}
.name-font{
  position: relative;
  left:70px;
  font-size: 20px;  
}
.name{
  position: relative;
  max-width:75%;
  left:70px;
}
.mail-font{
  position: relative;
  left:70px;
  font-size: 20px;
}
.mail{
  position: relative;
  max-width:78%;
  left:60px;
}
.password-font{
  position: relative;
  left:70px;
  top:20px;
  font-size: 20px;
}
.password{
  position: relative;
  max-width:78%;
  left:60px;
}
.look-font{
  position: relative;
  top:10px;
  left:30px;
}
.links{
  position: relative;
  left:50px;
  top:40px;
}
.download-font{
  position: relative;
  left:30px;
  top:70px;
}
.checkbox{
  position: relative;
  left:90px;
  top:140px;
}
.signupbtn{
  position: relative;
  left:90px;
  top:140px;
  width: 200px;  
}
.back{
  position: relative;
  top:80px;
  left:19%;
  font-size: 35px;
}

}

/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width:960px) and (max-width:1279px) {
.card{
  height: 500px;
}
.pic1{
  position: relative;
  max-width: 40%;
  left: 31%;
}
.back{
  position: relative;
  top:100px; 
}

.name-font{
  position: relative;
  left:70px;
  font-size: 20px;  
}
.name{
  position: relative;
  max-width:75%;
  left:70px;
}
.mail-font{
  position: relative;
  left:70px;
  font-size: 20px;
}
.mail{
  position: relative;
  max-width:78%;
  left:60px;
}
.password-font{
  position: relative;
  left:70px;
  top:20px;
  font-size: 20px;
}
.password{
  position: relative;
  max-width:78%;
  left:60px;
}
.look-font{
  position: relative;
  top:10px;
  left:30px;
}
.links{
  position: relative;
  left:50px;
  top:40px;
}
.download-font{
  position: relative;
  left:30px;
  top:70px;
  font-size: 12px;
}
.checkbox{
  position: relative;
  left:90px;
  top:140px;
}
.signupbtn{
  position: relative;
  left:90px;
  top:130px;  
}
.back{
  position: relative;
  top:30px;
  left:18%;
  font-size: 30px;
}
}

/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width:600px) and (max-width:959px) {
.pic1{
  position: relative;
  max-width: 50%;
  left: 31%;
}
.signup{
  position: relative;
  left: 70px;
  top:120px;
}
.back{
  position: relative;
  top:100px; 
}
.name-font{
  position: relative;
  left:30px;
  font-size: 20px;  
}
.name{
  position: relative;
  max-width:75%;
  left:30px;
}
.mail-font{
  position: relative;
  left:28px;
  font-size: 20px;
}
.mail{
  position: relative;
  max-width:78%;
  left:20px;
}
.password-font{
  position: relative;
  left:30px;
  top:20px;
  font-size: 20px;
}
.password{
  position: relative;
  max-width:78%;
  left:20px;
}
.look-font{
  position: relative;
  top:10px;
}
.rule{
  font-size: 14px;
}
.links{
  position: relative;
  
  top:40px;
}
.download-font{
  position: relative;
  
  top:70px;
}
.checkbox{
  position: relative;
  left:60px;
  top:140px;
}
.signupbtn{
  position: relative;
  left:60px;
  top:140px;  
}
.back{
  position: relative;
  top:60px;
  left:17%;
  font-size: 30px;
}
}

/* 480px〜599px：SP横
------------------------------ */
@media screen and (min-width:480px) and (max-width:599px) {
.pic1{
  position: relative;
  max-width: 60%;
  left: 25%;
}
.signup{
  position: relative;
  left: 70px;
  top:120px;
}
.back{
  position: relative;
  top:100px; 
}
.name-font{
  position: relative;
  left:10px;
  font-size: 15px;  
}
.name{
  position: relative;
  max-width:90%;
  left:10px;
}
.mail-font{
  position: relative;
  left:10px;
  font-size: 15px;
}
.mail{
  position: relative;
  max-width:100%;
}
.password-font{
  position: relative;
  left:10px;
  top:20px;
  font-size: 15px;
}
.password{
  position: relative;
  max-width:100%;
  
}
.rule{
  font-size:14px;
}
.look-font{
  position: relative;
  
  left:10px;
}
.links{
  position: relative;
  left:10px;
  top:40px;
}
.download-font{
  position: relative;
  left:10px;
  top:70px;
}
.checkbox{
  position: relative;
  top:70px;
  left:10px;
  font-size: 10px;
}
.signupbtn{
  position: relative;
  top:70px;
  left:25px;
}
.back{
  position: relative;
  top:40px;
  left:16%;
  font-size: 20px;
}
}
/* 〜479px：スマートフォン縦
------------------------------ */
@media screen and (max-width:479px){
.card{
  max-width: 83%;
  left:5%;
}
.pic1{
  max-width: 90%;
  position: relative;
  left: 8%;
}
.signup{
  position: relative;
  left: 70px;
  top:120px;
}
.back{
  position: relative;
  top:100px; 
}
.name-font{
  position: relative;
  font-size: 18px; 
  max-width: 90%; 
}
.name{
  position: relative;
  max-width: 290px;
}
.mail-font{
  position: relative;
  font-size: 18px;
  right:2px;
}
.mail{
  position: relative;
  width: 290px;
  right:9px;
}
.password-font{
  position: relative;
  font-size: 18px;
  right:0px;
}
.password{
  position: relative;
  right:10px;
  max-width: 58%;
}
.rule{
  font-size: 10px;
}
.look-font{
  position: relative;
  font-size: 16px;
  width:300px;
  
}
.links{
  position: relative;
  width:300px; 
}
.download-font{
  position: relative;
  width:280px;
  font-size: 13px;
  top:10px;
}
.checkbox{
  position: relative;
  left:50px;
  width: 500px;
  top: 10px;
}
.signupbtn{
  position: relative;
  top:20px;
  left:30%;  
}
.back{
  position: relative;
  top:30px;
  left:13%;
  font-size: 20px;
}
}

</style>